import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import ChartCard from "./ChartCard";
import {
  CHART_COLORS,
  getChartTheme,
  shortLabel,
} from "../utils/chartTheme";

function GroupedChart({ title, data, isDarkMode }) {
  const theme = getChartTheme(isDarkMode);
  const chartH = Math.max(300, Math.min(440, 48 + data.length * 36));
  const rows = data.map((r) => ({
    ...r,
    label: shortLabel(r.name, 22),
  }));

  return (
    <ChartCard
      title={title}
      empty={!data.length}
      height={chartH}
      accent={CHART_COLORS.teal}
    >
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={rows}
          layout="vertical"
          margin={{ top: 4, right: 16, left: 4, bottom: 4 }}
          barCategoryGap="22%"
          barGap={3}
        >
          <CartesianGrid {...theme.cartesianProps} horizontal={false} />
          <XAxis
            type="number"
            tick={theme.tickProps}
            axisLine={theme.axisLine}
            tickLine={theme.tickLine}
          />
          <YAxis
            type="category"
            dataKey="label"
            width={128}
            tick={theme.tickProps}
            axisLine={theme.axisLine}
            tickLine={false}
          />
          <Tooltip
            contentStyle={theme.tooltipContentStyle}
            labelStyle={theme.tooltipLabelStyle}
            itemStyle={theme.tooltipItemStyle}
            labelFormatter={(_, payload) => payload?.[0]?.payload?.name || ""}
            cursor={{
              fill: isDarkMode
                ? "rgba(255,255,255,0.04)"
                : "rgba(29,52,69,0.04)",
            }}
          />
          <Legend {...theme.legendProps} />
          <Bar
            dataKey="total"
            name="Ore totale"
            fill={CHART_COLORS.teal}
            radius={[0, 6, 6, 0]}
            barSize={12}
          />
          <Bar
            dataKey="ot"
            name="OT"
            fill={CHART_COLORS.yellow}
            radius={[0, 6, 6, 0]}
            barSize={12}
          />
        </BarChart>
      </ResponsiveContainer>
    </ChartCard>
  );
}

export default function DeptTeamCharts({
  byDepartment = [],
  byTeam = [],
  isDarkMode = false,
}) {
  return (
    <div className="analytics-grid analytics-grid--2">
      <GroupedChart
        title="Sipas departamentit"
        data={byDepartment}
        isDarkMode={isDarkMode}
      />
      <GroupedChart
        title="Sipas ekipit"
        data={byTeam}
        isDarkMode={isDarkMode}
      />
    </div>
  );
}
